export default __webpack_public_path__ + "static/media/Matting.677a055f.png";